import './App.css';
import Login from './views/auth/Login';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NotFoundPage from './views/NotFoundPage';
import { observer } from 'mobx-react-lite';
import theme from './common/theme';
import { ThemeProvider } from 'styled-components';
import { analytics } from './common/firebase/Firebase';
import { useEffect } from 'react';
import ProtectedRoute from './common/utils/ProtectedRoute';
import RoleBasedRoute from './common/utils/RoleBasedRoute';
import MainHome from './views/MainHome';
import AccountMain from './views/account/AccountMain';
import AccountAdd from './views/account/AccountAdd';
import AccountChangePassword from './views/account/AccountChangePassword';
import CustomerInquiries from './views/homepage/CustomerInquiries';
import HomePageInfo from './views/homepage/HomePageInfo';
import BBBoard from './views/archive/BBBoard';
import BBGallery from './views/archive/BBGallery';
import FindUsername from './views/auth/FindUsername';
import FindUsernameResult from './views/auth/FindUsernameResult';
import ChangePasswordStep1 from './views/auth/ChangePasswordStep1';
import ChangePasswordStep2 from './views/auth/ChangePasswordStep2';
import CreatePost from './views/archive/CreatePost';
import BoardDetail from './views/archive/BoardDetail';
import InternalBoard from './views/archive/InternalBoard';
import InternalGallery from './views/archive/InternalGallery';
import CustomerReports from './views/homepage/CustomerReports';
import CustomerReportsDetail from './views/homepage/CustomerReportsDetail';
import ContactPersons from './views/homepage/ContactPersons';
import CustomerReportsReply from './views/homepage/CustomerReportsReply';
import CustomerInquiriesDetail from './views/homepage/CustomerInquiriesDetail';
import CustomerInquiriesReply from './views/homepage/CustomerInquiriesReply';
import RecruitBoard from './views/board/RecruitBoard';
import RecruitBoardAdd from './views/board/RecruitBoardAdd';
import RecruitBoardDetail from './views/board/RecruitBoardDetail';
import RecruitBoardEdit from './views/board/RecruitBoardEdit';
import RequestHomepageWork from './views/homepage/RequestHomepageWork';
import PatentBoard from './views/board/PatentBoard';
import PatentBoardAdd from './views/board/PatentBoardAdd';
import PatentBoardEdit from './views/board/PatentBoardEdit';
import PatentBoardDetail from './views/board/PatentBoardDetail';
import MarketingBoard from './views/board/MarketingBoard';
import MarketingBoardAdd from './views/board/MarketingBoardAdd';
import MarketingBoardDetail from './views/board/MarketingBoardDetail';
import MarketingBoardEdit from './views/board/MarketingBoardEdit';
import NoticeBoard from './views/board/NoticeBoard';
import NoticeBoardAdd from './views/board/NoticeBoardAdd';
import NoticeBoardEdit from './views/board/NoticeBoardEdit';
import NoticeBoardDetail from './views/board/NoticeBoardDetail';

const App = observer(() => {
    useEffect(() => {
        console.log("Firebase initialized:", {
            analytics
        });
    }, []);
    
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    {/* 모든 사용자 접근 가능 */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/change-password/step1" element={<ChangePasswordStep1 />} />
                    <Route path="/change-password/step2" element={<ChangePasswordStep2 />} />
                    <Route path="/find-username" element={<FindUsername />} />
                    <Route path="/find-username/result" element={<FindUsernameResult />} />
                    <Route path="*" element={<NotFoundPage />} /> 잘못된 URL 처리
                    {/* 🔒 보호된 라우트 - 로그인 필요 */}
                    <Route element={<ProtectedRoute />}>
                        {/* 일반 관리자 접근 가능 */}
                        <Route path="/" element={<MainHome />} />
                        <Route path="/homepage/inquiries" element={<CustomerInquiries />} />
                        <Route path="/homepage/inquiries/detail" element={<CustomerInquiriesDetail />} />
                        <Route path="/homepage/inquiries/reply" element={<CustomerInquiriesReply />} />
                        <Route path="/homepage/contactperson" element={<ContactPersons />} />
                        <Route path="/homepage/info" element={<HomePageInfo />} />
                        <Route path="/homepage/requesthomepagework" element={<RequestHomepageWork />} />
                        <Route path="/board/marketing" element={<MarketingBoard />} />
                        <Route path="/board/marketing/add" element={<MarketingBoardAdd />} />
                        <Route path="/board/marketing/edit" element={<MarketingBoardEdit />} />
                        <Route path="/board/marketing/detail" element={<MarketingBoardDetail />} />
                        <Route path="/board/recruit" element={<RecruitBoard />} />
                        <Route path="/board/recruit/add" element={<RecruitBoardAdd />} />
                        <Route path="/board/recruit/edit" element={<RecruitBoardEdit />} />
                        <Route path="/board/recruit/detail" element={<RecruitBoardDetail />} />
                        <Route path="/board/patent" element={<PatentBoard />} />
                        <Route path="/board/patent/add" element={<PatentBoardAdd />} />
                        <Route path="/board/patent/edit" element={<PatentBoardEdit />} />
                        <Route path="/board/patent/detail" element={<PatentBoardDetail />} />
                        <Route path="/board/notice" element={<NoticeBoard />} />
                        <Route path="/board/notice/add" element={<NoticeBoardAdd />} />
                        <Route path="/board/notice/edit" element={<NoticeBoardEdit />} />
                        <Route path="/board/notice/detail" element={<NoticeBoardDetail />} />
                        <Route path="/archive/bbboard" element={<BBBoard />} />
                        <Route path="/archive/bbboard/detail" element={<BoardDetail boardId='bbboard' boardName='BB게시판' />} />
                        <Route path="/archive/interboard" element={<InternalBoard />} />
                        <Route path="/archive/interboard/detail" element={<BoardDetail boardId='interboard' boardName='사내전용게시판' />} />
                        <Route path="/archive/bbgallery" element={<BBGallery />} />
                        <Route path="/archive/bbgallery/detail" element={<BoardDetail boardId='bbgallery' boardName='BB갤러리' />} />
                        <Route path="/archive/intergallery" element={<InternalGallery />} />
                        <Route path="/archive/intergallery/detail" element={<BoardDetail boardId='intergallery' boardName='사내전용갤러리' />} />
                        
                        {/* 슈퍼 관리자만 접근 가능 */}
                        <Route element={<RoleBasedRoute requiredRole="super" />}>
                            <Route path="/homepage/reports" element={<CustomerReports />} />
                            <Route path="/homepage/reports/detail" element={<CustomerReportsDetail />} />
                            <Route path="/homepage/reports/reply" element={<CustomerReportsReply />} />
                            <Route path="/account" element={<AccountMain />} />
                            <Route path="/account/add" element={<AccountAdd />} />
                            <Route path="/account/change-password" element={<AccountChangePassword />} />
                        </Route>
                    </Route>
                </Routes>
            </Router>
        </ThemeProvider>
    );
});

export default App;